import { createSliceSelectors } from '../core/selectors/utils'

const ConfigSelectors = createSliceSelectors('config', [
    /* isVRButtonEnabled */

    'isVRButtonEnabled',
    /* areShareButtonsEnabled */

    'areShareButtonsEnabled',
    /* areActionButtonsEnabled */

    'areActionButtonsEnabled',
])

export default ConfigSelectors
